import { useCallback } from 'react'

import { AuthChecker } from '../../hoc/withPermissions'
import { useAuth } from '../useAuth/useAuth'

export function usePermission() {
  const { state } = useAuth()

  const has = useCallback(
    (...checkers: AuthChecker[]) => {
      return state.status === 'authorized' && checkers.every(checker => checker({ state }))
    },
    [state]
  )

  return has
}
